export default "__VITE_ASSET__DOItpkyg__"